export default {
  'NEW': {
    label: 'Przygotowanie',
    style: 'warning',
    outline: false
  },
  'IN_PREPARATION': {
    label: 'Wysłane do realizacji',
    style: 'primary',
    outline: false
  },
  'SENT': {
    label: 'Wysłane do magazynu',
    style: 'success',
    outline: true
  }
};
